<div class="date-field-group d-flex align-items-end">
  <div class="month">
    <ds-dropdown
      data-id="month-of-birth"
      placeholder="Month"
      [value]="month"
      [touched]="showFieldErrors"
      [disabled]="formControl.disabled"
      [errors]="formControl.errors"
      [options]="months"
      (selectOption)="setMonth($event)"
      (markAsTouched)="onMonthTouched()"
    />
  </div>

  <div class="day">
    <ds-input
      #dayInput
      placeholder="Day"
      inputmode="numeric"
      maxlength="2"
      autocomplete="bday-day"
      enterkeyhint="next"
      [inputId]="id + '-day'"
      data-id="day-of-birth"
      [value]="day"
      [disabled]="formControl.disabled"
      [invalid]="showFieldErrors"
      (valueChange)="onDayChange($event)"
      (keydown)="onDayKeydown($event)"
      (blurred)="onDayBlur()"
    />
  </div>

  <div class="year">
    <ds-input
      #yearInput
      placeholder="Year"
      inputmode="numeric"
      maxlength="4"
      autocomplete="bday-year"
      enterkeyhint="next"
      [inputId]="id + '-year'"
      data-id="year-of-birth"
      [value]="year"
      [disabled]="formControl.disabled"
      [invalid]="showFieldErrors"
      (valueChange)="onYearChange($event)"
      (keydown)="onYearKeydown($event)"
      (blurred)="onYearBlur()"
    />
  </div>
</div>
